// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-30230766-3',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production' // Only track users on production build
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
